import {
  Component,
  HostBinding,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'jam-icon',
  templateUrl: './jam.component.html',
  styleUrls: ['./jam.component.scss'],
})
export class JamComponent implements OnInit {
  @Input('name') name!: string;
  @Input('size') fontSize!: number;
  @Input('vertical-align') verticalAlign!: string;
  @Input('color') color!: 'primary' | 'accent' | 'warn' | '';

  @Input('margins') margin?: string = '5px';

  @HostBinding('class.jam-icon-wrapper') class = () => true;
  @ViewChild('icon') icon!: any;

  constructor() {}
  ngOnInit(): void {
    setTimeout(() => {
      this.icon.nativeElement.style.verticalAlign = this.verticalAlign;
      this.icon.nativeElement.style.margin = `0 ${this.margin} 0 ${this.margin}`;
    }, 0);
  }
}
